// extracted by mini-css-extract-plugin
export default {"container":"Services_container__mS8Ul"};